import { render, staticRenderFns } from "./FaqCloseIcon.vue?vue&type=template&id=e0976748&scoped=true"
import script from "./FaqCloseIcon.vue?vue&type=script&lang=js"
export * from "./FaqCloseIcon.vue?vue&type=script&lang=js"
import style0 from "./FaqCloseIcon.vue?vue&type=style&index=0&id=e0976748&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0976748",
  null
  
)

export default component.exports